<template>
  <div class="page-footer">
    <div class="show-w">
      <div class="info">
        <div class="logo">
          <img src="@/assets/logo-b.png"/>
        </div>
        <div class="mailbox">
          www.regopimc.com
        </div>
        <div class="address">

        </div>
      </div>
      <div class="line"></div>
      <div class="entry">
        <div class="title">
          快速入口
        </div>
        <div class="module">
          <!--<div @click="toUrl('/platform_0')">
            互娱权益平台
          </div>-->
          <div @click="toUrl('/goods')">
            虚拟商品采购及交付
          </div>
        </div>
        <div class="module">
          <!--<div @click="toUrl('/platform_1')">
            广告营销平台
          </div>-->
          <div @click="toUrl('/advert')">
            推广及广告服务
          </div>
        </div>
        <div class="module">
          <!--<div @click="toUrl('/platform_2')">
            SaaS服务平台
          </div>-->
          <div @click="toUrl('/game')">
            手游/软件开发及维护
          </div>
        </div>
        <div class="module">
          <!--<div @click="toUrl('/platform_2')">
            SaaS服务平台
          </div>-->
          <div @click="toUrl('/lottery')">
            一站式彩票解决方案
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="entry">
        <div class="title">
          快速入口
        </div>
        <!--<div class="recommend icon_0">
          <div>
            推荐至微博
          </div>
        </div>
        <div class="recommend icon_1">
          <div>
            推荐至QQ空间
          </div>
        </div>-->
        <div class="recommend " @click="toUrl('/join')">
          <div>
            招贤纳士
          </div>
        </div>
        <div class="recommend" @click="toUrl('/contact')">
          <div>
            联系我们
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="entry w300">
        <div class="title">
          杭州润歌网络有限公司
        </div>
        <div>
          <!--为中小企业提供信息化、电商化、互联网化的整体解决方案，真正做到让天下没有难做的企业-->
          杭州市富阳区银湖街道银溪路77号<br/>润歌互动总部大厦19楼
        </div>
        <div class="code">
          <!--<div class="saoyisao">
            <img src="@/assets/erweim.png">
            <br/>
            扫码体验
          </div>
          <div class="saoyisao">
            <img src="@/assets/erweim.png">
            <br/>
            关注我们
          </div>-->
        </div>
      </div>
    </div>
    <div class="show-w copyright">
      Copyright 2009-现在 杭州润歌网络有限公司 版权所有 <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备18009425号-1</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageFooter',
    data() {
      return {}
    },
    methods: {
      toUrl(url) {
        if (url && this.$route.path != url) {
          this.$router.push(url);
          window.scrollTo(0, 0);
        }
      }
    }
  }
</script>

<style scoped>
  .page-footer {
    height: 300px;
    background: #FF722F;
    z-index: 99;
    position: relative;
  }

  .info {
    margin: 30px 50px 0 0px;
    width: 232px;
    float: left;
  }

  .page-footer .info .logo img {
    height: 49px;
    width: 172px;
  }

  .page-footer .info .mailbox {
    margin-top: 10px;
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    color: #FFFFFF;
  }

  .page-footer .info .address {
    font-size: 14px;
    line-height: 20px;
    margin-top: 20px;
    font-weight: bold;
    color: #FFFFFF;
  }

  .page-footer .entry {
    margin: 30px 50px;
    float: left;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 20px;
  }

  .page-footer .entry .title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .page-footer .entry .module {
    display: flex;
    width: 250px;
    margin-top: 15px;
  }

  .page-footer .entry .module > div {
    flex: 4;
    text-align: left;
    cursor: pointer;
  }

  .page-footer .entry .module > div:first-child {

    flex: 3;
  }

  .page-footer .entry .recommend {
    margin-top: 15px;
    cursor: pointer;
  }
  .icon_0::before {
    background: url(../assets/weibo.png);
  }

  .icon_1::before {
    background: url(../assets/qq.png);
  }

  .page-footer .entry:last-child {
    margin-right: 0;
  }

  .page-footer .entry .code {
    margin-top: 15px;
  }

  .page-footer .entry .code .saoyisao {
    color: #FFFFFF;
    text-align: center;
    float: left;
    margin-right: 50px;
  }

  .page-footer .entry .code .saoyisao img {
    width: 70px;
    margin-bottom: 8px;
  }

  .copyright {
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
  }
  .copyright a{
    color: #FFFFFF;
  }
  .line {
    width: 2px;
    margin: 70px 0;
    height: 120px;
    float: left;
    border: 1px solid rgba(255, 255, 255, 0.25);
  }

  .w300 {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue